import React, { useEffect, useRef, useState } from "react";
import CheckRoundedIcon from "@material-ui/icons/CheckRounded";
import PublicOutlinedIcon from "@material-ui/icons/PublicOutlined";
import AppsRoundedIcon from "@material-ui/icons/AppsRounded";

const CountryChoice = ({ country, label, selected, onSelect }) => {
  const [flagFailed, setFlagFailed] = useState(false);
  const flag = typeof country.flag === "string" ? country.flag.trim() : "";
  return (
    <button type="button" className="context-country__choice" aria-pressed={selected}
      onClick={() => onSelect(country.id)}>
      <span className="context-country__flag" aria-hidden="true">
        {flag && !flagFailed
          ? <img src={flag} alt="" onError={() => setFlagFailed(true)} />
          : <PublicOutlinedIcon />}
      </span>
      <span className="context-country__name">{label}</span>
      <span className="context-country__check" aria-hidden="true">{selected && <CheckRoundedIcon />}</span>
    </button>
  );
};

export default function ContextCountryChoices({ countries, selectedId, onSelect, language, getLabel }) {
  const arabic = language === "arabic";
  const label = arabic ? "الدولة" : "Country";
  const [expanded, setExpanded] = useState(false);
  const [query, setQuery] = useState("");
  const rail = useRef(null);
  const toggle = useRef(null);
  useEffect(() => {
    const element = rail.current;
    const selected = element?.querySelector('[aria-pressed="true"]');
    if (!selected) return;
    // Reveal the selection inside the rail without scrolling the drawer/page.
    const outer = element.getBoundingClientRect();
    const inner = selected.getBoundingClientRect();
    if (inner.left < outer.left) element.scrollLeft += inner.left - outer.left - 3;
    else if (inner.right > outer.right) element.scrollLeft += inner.right - outer.right + 3;
  }, [selectedId, expanded, language]);
  const choose = countryId => {
    if (String(countryId) !== String(selectedId)) onSelect(countryId);
    if (expanded) {
      setExpanded(false);
      setQuery("");
      if (toggle.current) toggle.current.focus({ preventScroll: true });
    }
  };
  const shownCountries = expanded && query.trim()
    ? countries.filter(country => `${getLabel(country, false)} ${getLabel(country, true)}`.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase()))
    : countries;
  return (
    <div className="context-country" role="group" aria-label={label} dir={arabic ? "rtl" : "ltr"}>
      <div className="context-country__heading">
        <span className="context-sheet__field-label">{label}</span>
        <button type="button" className="context-country__toggle" ref={toggle} aria-expanded={expanded}
          onClick={() => { setExpanded(!expanded); setQuery(""); }}>
          <AppsRoundedIcon aria-hidden="true" />
          {expanded ? (arabic ? "إغلاق القائمة" : "Close list") : (arabic ? "كل الدول" : "All countries")}
          {!expanded && <span className="context-country__count">{countries.length}</span>}
        </button>
      </div>
      {expanded && countries.length > 8 && <input className="context-country__search" type="search" value={query}
        aria-label={arabic ? "ابحث عن دولة" : "Search countries"} placeholder={arabic ? "ابحث عن دولة" : "Search countries"}
        onChange={event => setQuery(event.target.value)} />}
      <div className={expanded ? "context-country__grid" : "context-country__rail"} ref={expanded ? null : rail}>
        {shownCountries.map(country => <CountryChoice key={`${country.id}:${country.flag || ""}`} country={country}
          label={getLabel(country, arabic)} selected={String(country.id) === String(selectedId)} onSelect={choose} />)}
        {!shownCountries.length && <p className="context-country__empty" role="status">{arabic ? "لا توجد دولة مطابقة" : "No matching country"}</p>}
      </div>
    </div>
  );
}
